"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FolderIcon = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var SVGBox_1 = require("./SVGBox");
var themes_1 = require("../../themes");
var RegularSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.fill2, fill2 = _c === void 0 ? themes_1.THEME.colors.basic.White100 : _c, size = _a.size, rest = __rest(_a, ["fill", "fill2", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 24 24" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M0.5 3C0.5 2.17157 1.17157 1.5 2 1.5H8.92963C9.43116 1.5 9.89951 1.75065 10.1777 2.16795L10.9902 3.38675C11.4539 4.08225 12.2345 4.5 13.0704 4.5H22C22.8284 4.5 23.5 5.17157 23.5 6V21C23.5 21.8284 22.8284 22.5 22 22.5H2C1.17157 22.5 0.5 21.8284 0.5 21V3Z", stroke: "black", strokeWidth: "1", fill: fill ? fill2 : 'transparent' }, void 0),
            jsx_runtime_1.jsx("rect", { x: "0.5", y: "7.5", width: "23", height: "15", rx: "1.5", stroke: "black", strokeWidth: "1", fill: fill }, void 0)] }), void 0));
};
var BigSizedIcon = function (_a) {
    var _b = _a.fill, fill = _b === void 0 ? 'transparent' : _b, _c = _a.fill2, fill2 = _c === void 0 ? themes_1.THEME.colors.basic.White100 : _c, size = _a.size, rest = __rest(_a, ["fill", "fill2", "size"]);
    return (jsx_runtime_1.jsxs(SVGBox_1.SVGBox, __assign({ size: size, viewBox: "0 0 32 32" }, rest, { children: [jsx_runtime_1.jsx("path", { d: "M0.75 4.00001C0.75 2.94147 1.60812 2.08334 2.66667 2.08334H11.9062C12.547 2.08334 13.1455 2.40362 13.5009 2.93683L14.5843 4.5619C15.218 5.51241 16.2848 6.08334 17.4272 6.08334H29.3333C30.3919 6.08334 31.25 6.94146 31.25 8.00001V28C31.25 29.0586 30.3919 29.9167 29.3333 29.9167H2.66667C1.60812 29.9167 0.75 29.0586 0.75 28V4.00001Z", stroke: "black", strokeWidth: "1.5", fill: fill ? fill2 : 'transparent' }, void 0),
            jsx_runtime_1.jsx("rect", { x: "0.75", y: "10.0833", width: "30.5", height: "19.8333", rx: "1.91667", stroke: "black", strokeWidth: "1.5", fill: fill }, void 0)] }), void 0));
};
var FolderIcon = function (props) {
    var _a = props.size, size = _a === void 0 ? 24 : _a, rest = __rest(props, ["size"]);
    return size < 32 ? (jsx_runtime_1.jsx(RegularSizedIcon, __assign({ size: size }, rest), void 0)) : (jsx_runtime_1.jsx(BigSizedIcon, __assign({ size: size }, rest), void 0));
};
exports.FolderIcon = FolderIcon;
//# sourceMappingURL=FolderIcon.js.map